module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Thunder-9eb169b08928f5007f54b825d16e0f23.svg";